import React, { useContext } from 'react';
import { IconButton, Paper, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx/xlsx.mjs';

import { DataContext } from '../context/DataContext';
import { getConamiReportAsync } from '../api/AdmonReport';
import { getToken } from '../api/Account';
import { simpleMessage } from '../helpers/Helpers';
import moment from 'moment';

const CallerDownLoadSinRiesgo = ({ icon, text }) => {
	const { setIsLoading, setIsUnautorized } = useContext(DataContext);

	const token = getToken();

	const downLoadData = async () => {
		Swal.fire({
			title: '¿Estas Seguro?',
			text: 'Estas por descargar toda la base de credito...!',
			icon: 'question',
			showCancelButton: true,

			confirmButtonColor: '#2979ff',
			cancelButtonColor: '#f50057',

			confirmButtonText: 'Descargar!',
			cancelButtonText: 'Cancelar',
			customClass: {
				popup: 'border'
			}
		}).then((result) => {
			if (result.isConfirmed) {
				(async () => {
					setIsLoading(true);
					const data = {
						sucursalId: 0,
						Desde: moment().format('YYYY-MM-DD'),
						Hasta: moment().format('YYYY-MM-DD')
					};
					const result = await getConamiReportAsync(token, data);
					if (!result.statusResponse) {
						setIsLoading(false);
						if (result.error === 'Unauthorized') {
							setIsUnautorized(true);
							return;
						}
						simpleMessage(result.error, 'error');
						return;
					}

					exportExcel(result.data.result);
					setIsLoading(false);
					Swal.fire('Descargado!', 'Datos Descargados...', 'success');
				})();
			}
		});
	};

	const exportExcel = (data) => {
		let exp = [];
		let exp2 = [];

		data.pages1.map((item) => {
			// console.log(item)
			let obj = {
				'Tipo de Entidad': item.tipoEntidad,
				'Número Correlativo': item.numeroCorrelativo,
				'Fecha de Reporte': moment(item.fechaReporte).format('L'),
				Departamento: item.departmentConamiCode,
				'Número de Identificación': item.identification,
				'Nombres y Apellidos': item.clientName,
				'Tipo de Crédito': item.tipoCredito,
				'Fecha de Desembolso': moment(item.fechaDesembolso).format('L'),
				'Tipo de Obligación': item.tipoObligacion,
				'Monto Autorizado': item.montoAutorizado,
				'Plazo (Meses)': item.plazoDias,
				'Frecuencia de Pago': item.frecuenciaPago,
				'Saldo  de Deuda (a la fecha de reporte ).': item.saldoDeuda,
				'Estado del Crédito': item.estadoCredito,
				'Monto Vencido': item.montoVencido,
				'Antigüedad de Mora (Dias)': item.antiguedadMora,
				'Tipo de Garantia': item.tipoGarantia,
				'Forma de Recuperación': item.formaRecuperacion,
				'Numero de credito': item.numeroCredito,
				'Monto Cuota (Según la Frecuencia de Pago)': item.montoCuota
			};

			exp.push(obj);
		});
		data.pages2.map((item) => {
			let obj = {
				'Número Correlativo': item.numeroCorrelativo,
				'Fecha de Reporte': moment(item.fechaReporte).format('L'),
				Identificación: item.identification,
				'Tipo De Persona': item.tipoPersona,
				Nacionalidad: item.nacionalidad,
				Sexo: item.sexo,
				'Fecha De Nacimiento': item.fechaNacimiento,
				'Estado Civil': item.estadoCivil,
				'Dirección Domicilio': item.direccionDomicilio,
				'Departamento Domicilio': item.departamentoDomicilio,
				'Municipio Domicilio': item.municipioDomicilio,
				'Dirección Trabajo': item.direccionTrabajo,
				'Departamento Trabajo': item.departamentoTrabajo,
				'Municipio Trabajo': item.municipioTrabajo,
				'Telefono Domiciliar': item.telefonoDomiciliar,
				'Telefono Trabajo': item.telefonoTrabajo,
				Celular: item.celular,
				'Correo Electronico': item.email,
				Ocupacion: item.ocupacion,
				'Actividad Economica': item.actividadEconomica,
				Sector: item.sector
			};

			exp2.push(obj);
		});
		var bk = XLSX.utils.book_new(),
			bs = XLSX.utils.json_to_sheet(exp),
			bs2 = XLSX.utils.json_to_sheet(exp2);

		XLSX.utils.book_append_sheet(bk, bs, 'Hoja1');
		XLSX.utils.book_append_sheet(bk, bs2, 'Hoja2');
		XLSX.writeFile(bk, 'SinRiesgo.xlsx');
	};

	return (
		<div>
			<Paper
				elevation={10}
				style={{
					textAlign: 'center',
					padding: 15
				}}
			>
				<IconButton
					onClick={() => downLoadData()}
					sx={{
						border: 1,
						borderColor: 'rgba(54, 162, 235, 1)',
						p: 2,
						mb: 1
					}}
					style={{
						backgroundColor: 'rgba(54, 162, 235, 0.2)'
					}}
				>
					<FontAwesomeIcon
						icon={icon}
						style={{ color: 'rgba(54, 162, 235, 1)', width: 50, height: 50 }}
					/>
				</IconButton>
				<hr />
				<Typography
					fontSize={18}
					fontWeight={'bold'}
					style={{ color: 'rgba(54, 162, 235, 1)' }}
				>
					{text}
				</Typography>
			</Paper>
		</div>
	);
};

export default CallerDownLoadSinRiesgo;
